<template>
  <v-layout wrap>
    <v-flex v-if="gettingData">
      <v-card class="pa-2 ma-1 text-xs-center" to="/JobList">
        <v-progress-circular :size="60" :width="8" color="primary" indeterminate></v-progress-circular>
        <div class="title">Fetching Recent Job Status</div>
      </v-card>
    </v-flex>
    <template v-else>
      <v-flex>
        <v-card class="pa-2 ma-1 text-xs-center" to="/JobList">
          <v-progress-circular :size="60" :width="8" :rotate="360" :value="jobsNotStarted / data.length * 100" color="primary">
            {{jobsNotStarted}}
          </v-progress-circular>
          <div class="caption">Jobs Not Started</div>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="pa-2 ma-1 text-xs-center" to="/JobList">
          <v-progress-circular :size="60" :width="8" :rotate="360" :value="jobsStarted / data.length * 100" color="info">
            {{jobsStarted}}
          </v-progress-circular>
          <div class="caption">Jobs Started</div>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="pa-2 ma-1 text-xs-center" to="/Outbox">
          <v-progress-circular :size="60" :width="8" :rotate="360" :value="jobsNotUploaded / data.length * 100" color="error">
            {{jobsNotUploaded}}
          </v-progress-circular>
          <div class="caption">Jobs Not Uploaded</div>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="pa-2 ma-1 text-xs-center" @click="completedDialog = true">
          <v-progress-circular :size="60" :width="8" :rotate="360" :value="jobsCompleted / data.length * 100" color="success">
            {{jobsCompleted}}
          </v-progress-circular>
          <div class="caption">Jobs Completed Last 14 Days</div>
        </v-card>
      </v-flex>
    </template>
    <v-dialog v-model="completedDialog" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Completed Jobs Last 14 Days</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="completedDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list dark three-line v-for="(job, i) in completedJobs" v-bind:key="i" class="green mb-2">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>{{ job.Vehicle ? vehicleRegFromID(job.Vehicle) : job.vehReg }}</v-list-tile-title>
              <v-list-tile-sub-title>Job ID: {{job.JobNo}}</v-list-tile-sub-title>
              <v-list-tile-sub-title>Completed: {{job.CompletedDate | formatDate}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { fireStore } from '../../firebase'
import moment from 'moment'
export default {
  name: 'StatusOverview',
  data () {
    return {
      gettingData: false,
      data: [],
      jobsNotStarted: 0,
      jobsStarted: 0,
      jobsCompleted: 0,
      jobsNotUploaded: 0,
      listener: null,
      completedDialog: false,
      completedJobs: []
    }
  },
  created () {
    this.getData()
  },
  beforeDestroy () {
    this.listener()
  },
  methods: {
    getData () {
      this.gettingData = true
      this.listener = fireStore.collection('Jobs').where('Allocated', '==', this.user.id).orderBy('CompletedDate', 'desc').onSnapshot(
        snap => {
          this.data = []
          this.jobsNotStarted = 0
          this.jobsStarted = 0
          this.jobsCompleted = 0
          this.jobsNotUploaded = 0
          this.completedJobs = []
          snap.forEach(doc => {
            if (doc.data().CompletedDate) {
              if (moment(doc.data().CompletedDate) < moment().add(-14, 'days')) {
                return
              }
              this.jobsCompleted++
              this.completedJobs.push(doc.data())
            } else if (!doc.data().jobStarted) {
              this.jobsNotStarted++
              console.log(doc.data())
            } else if (doc.data().jobEnded) {
              this.jobsNotUploaded++
            } else {
              this.jobsStarted++
            }
            this.data.push(doc.data())
          })
          this.gettingData = false
        })
    },
    vehicleRegFromID (id) {
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.id === id
      })
      if (index > -1) {
        return this.vehicles[index]['VehicleReg']
      } else {
        return ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    vehicles () {
      return this.$store.getters.vehicles
    }
  },
  filters: {
    formatDate (val) {
      return moment(val).format('DD/MM/YYYY')
    }
  }
}
</script>


// WEBPACK FOOTER //
// StatusOverview.vue?48ab1ac7